import { baseTypography } from '../typography'
import type { ComponentStyleConfig } from '@chakra-ui/theme'

export const Link = {
  baseStyle: baseTypography.link,
} as ComponentStyleConfig
